import { render, staticRenderFns } from "./SendSmsDialogNew.vue?vue&type=template&id=27ced5a4&scoped=true&"
import script from "./SendSmsDialogNew.vue?vue&type=script&lang=js&"
export * from "./SendSmsDialogNew.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsDialogNew.vue?vue&type=style&index=0&id=27ced5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ced5a4",
  null
  
)

export default component.exports